import { combineReducers } from 'redux';
import fetchUserResponse from './fetchUserReducers';
import checkUser from './checkUserRegisterReducer';
import analyticData from './selectedBusinessReducers';
import fetchCameraResponse from './fetchCameraReducers';
import businessTokenMapping from './businessTokenMappingReducers';


export default combineReducers({
    fetchUserResponse,
    checkUser,
    analyticData,
    fetchCameraResponse,
    businessTokenMapping
 });